export const Week = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export interface ISettings {
  advertisement_tags: string[];
  client_lang_display: string;
  enable_rest_ad_control: boolean;
  isEnableBellRing: boolean;
  isSkippableToAssignTable: boolean;
  lineup: ILineUp;
  meny_service_class: IMenyServiceClass;
  name: string;
  ip_printer: string;
  opening_schedule: Schedule;
  isOnline: boolean;
  region: string;
  restaurant_open_id: string;
  restaurant_open_state: number;
  restaurant_operators: IRestaurantOperators[];
  restaurant_profile_pic: string;
  service_tags: IServiceTag[];
  stadium_id: string;
  status: string;
  merchant_id: string;
  location_id: string;
  large_paper: boolean;
  enable_regular_order?: boolean;
  enable_regular_pre_order?: boolean;
  enable_special_order?: boolean;
  enable_special_pre_order?: boolean;
  pre_order_email_addresses?: string[];
  email_address?: string;
  max_recommend_quantity?: number;
  preorder_rules?: {
    pre_order_email_addresses?: string[];
    acceptance?: IAcceptance;
    order_deliberable?: IOrderDeliberable;
  };
}

export interface IStadium {
  administrators: IAdministrators[];
  super_administrators?: IAdministrators[];
  enable_sales_count: boolean;
  seat_number: string;
  fileUrl: string;
  elepay_secret_key: string;
  elepay_public_key: string;
  id: string;
  isSeeAll: boolean;
  isStadiumPromotion: boolean;
  last_update_date: string;
  latest_id: number;
  name: string;
  promotion_restaurant_id: string;
  service_name: string;
  stadium_profile_pic: string;
  status: string;
  riders: IRiders[];
  enable_drink_quantity_control: boolean;
  enable_food_quantity_control: boolean;
  max_drink_quantity: number;
  max_food_quantity: number;
  phone?: string;
  address?: string;
  registration_code?: string;
  business_name?: string;
  zones?: IZone[];
  preorder_rules?: IPreorderRulesData;
  client_email_contacting?: IClientEmailContacting;
  astrolab_reminders?: IAstrolabReminders;
  cms_settings?: {
    pre_order: boolean;
    store_logic: boolean;
  };
}

export interface IZone {
  mapValue: string;
  zoneName: string;
}

export interface IAdministrators {
  uid: string;
  username: string;
}

export interface IRiders {
  uid: string;
  username: string;
}

export interface ScheduleItem {
  enabled: boolean;
  utc_start_time: string;
  utc_end_time: string;
}

export interface Schedule {
  SUN: ScheduleItem;
  MON: ScheduleItem;
  TUE: ScheduleItem;
  WED: ScheduleItem;
  THU: ScheduleItem;
  FRI: ScheduleItem;
  SAT: ScheduleItem;
}

export interface ILineUp {
  lineup_table_placeholder: string;
  lineup_username_placeholder: string;
  max_num_of_adult: number;
  max_num_of_children: number;
}

export interface IMenyServiceClass {
  id: number;
  name: string;
}

export interface IServiceTag {
  id: number;
  name: string;
}

export interface IRestaurantOperators {
  email: string;
  uid: string;
}

export interface IOrderNotification {
  order_deliver_unsuccess: boolean;
  order_delivered: boolean;
  order_success: boolean;
}

export interface IClientEmailContacting {
  gift_notification: IOrderNotification;
  order_for_himher: IOrderNotification;
  order_for_other: IOrderNotification;
}

export interface ITimeUnitValue {
  at?: string;
  time: number;
  type: string;
}

export interface ITimeUnitValueWithoutPicker {
  time: number;
  type: string;
}

export interface IAcceptance {
  since: ITimeUnitValue;
  until: ITimeUnitValue;
}

export interface IOrderDeliberable {
  since: ITimeUnitValueWithoutPicker;
  until: ITimeUnitValueWithoutPicker;
}

export interface IPreorderRules {
  acceptance: IAcceptance;
  time_slot: ITimeUnitValueWithoutPicker;
  order_deliberable: IOrderDeliberable;
}

export interface IExtraReminder {
  preorder_time_close: boolean;
  same_morning: boolean;
  switch_to_online: boolean;
}

export interface IAstrolabReminders {
  emails?: string[];
}

export interface IPreorderRulesData {
  preorder_rule?: IPreorderRules;
  client_email_contacting?: IClientEmailContacting;
  astrolab_reminders?: IAstrolabReminders;
}
